import React from "react";

import { useQuery, useMutation } from "@apollo/client";

import {
  manufacturerListQuery,
  deleteManufacturerMutation,
} from "graphql/manufacturer";

import BaseList from "./BaseList";

function ManufacturerList() {
  const { data: { manufacturerList: { edges = [] } = {} } = {} } = useQuery(
    manufacturerListQuery
  );

  const [deleteRow] = useMutation(deleteManufacturerMutation, {
    update(cache, result) {
      const data = cache.readQuery({ query: manufacturerListQuery });
      const nextData = {
        manufacturerList: data.manufacturerList.filter(
          (manufacturer) =>
            manufacturer.id !== result.data.deleteManufacturer.id
        ),
      };
      cache.writeQuery({
        query: manufacturerListQuery,
        data: nextData,
      });
    },
  });

  const columns = [
    {
      header: "Name",
      body: (item) => item.name,
    },
  ];

  return (
    <BaseList
      title="Manufacturers"
      rows={edges}
      deletePromise={deleteRow}
      columns={columns}
    />
  );
}

export default React.memo(ManufacturerList);
